import type { PortalWidgetStatus } from "@entrilia/shared/api/portalWidgetsTypes";
import StatusChip from "@entrilia/shared/components/StatusChip";

interface Props {
  status: PortalWidgetStatus;
}

const PortalWidgetStatusTag = ({ status }: Props) => {
  switch (status) {
    case "Live": {
      return <StatusChip label="Live" withDot color={(t) => t.palette.success.main} />;
    }
    case "Preview":
      return <StatusChip label="Preview" withDot color={(t) => t.palette.info.dark} />;
    case "Off":
      return <StatusChip label="Off" withDot color={(t) => t.palette.text.secondary} />;
    default:
      return null;
  }
};

export default PortalWidgetStatusTag;
